import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardIcon from "@mui/icons-material/Dashboard";
import ArticleIcon from "@mui/icons-material/Article";
import PhotoLibraryIcon from "@mui/icons-material/PhotoLibrary";
import PeopleIcon from "@mui/icons-material/People";
import LogoutIcon from "@mui/icons-material/Logout";
import "../../../css/admin/sidebar.scss";
import { useLogout } from "../../../queries";

const sidebarLinks = [
  { label: "داشبورد", icon: <DashboardIcon />, path: "/admin/adminpanel" },
  { label: "پست‌ها", icon: <ArticleIcon />, path: "/admin/createpost" },
  {
    label: "گالری تصاویر",
    icon: <PhotoLibraryIcon />,
    path: "/admin/creategallery",
  },
  { label: "بیماران", icon: <PeopleIcon />, path: "/admin/patientsList" },
];

const AdminSidebar: React.FC = () => {
  const location = useLocation();
  const history = useNavigate();
  const logoutMutation = useLogout();

  const handleLogout = () => {
    logoutMutation.mutate();
    history("/");
  };

  return (
    <aside className="adminSidebar">
      <div className="sidebarHeader" onClick={() => history("/")}>
        <img src="/favicon.png" alt="Logo" className="sidebarLogo" />
        <span className="sidebarTitle">پنل مدیریت</span>
      </div>
      <nav className="sidebarNav">
        {sidebarLinks.map((link) => (
          <div
            key={link.path}
            className={`sidebarNavItem${
              location.pathname === link.path ? " active" : ""
            }`}
            onClick={() => history(link.path)}
          >
            <span className="sidebarIcon">{link.icon}</span>
            <span className="sidebarLabel">{link.label}</span>
          </div>
        ))}
      </nav>
      <div className="sidebarFooter">
        <button className="logoutBtn" onClick={handleLogout}>
          <LogoutIcon />
          <span>خروج</span>
        </button>
      </div>
    </aside>
  );
};

export default AdminSidebar;
